import React from 'react';
import PropTypes from 'prop-types';
import { generateTaskChargeInvoicePDF } from '../../../utils/taskInvoice';

// Download / Print links for one task charge invoice (PDF generated on click).
const TaskInvoiceActions = ({ invoice }) => (
    <span className="d-inline-flex" style={{ gap: 12 }}>
        <button
            type="button"
            className="sortBtn linkBtn p-0"
            onClick={() => generateTaskChargeInvoicePDF(invoice)}
            aria-label={`Download invoice ${invoice.invoiceNumber}`}
        >
            <i className="fa fa-download mr-1" aria-hidden="true"></i>PDF
        </button>
        <button
            type="button"
            className="sortBtn linkBtn p-0"
            onClick={() => generateTaskChargeInvoicePDF(invoice, { print: true })}
            aria-label={`Print invoice ${invoice.invoiceNumber}`}
        >
            <i className="fa fa-print mr-1" aria-hidden="true"></i>Print
        </button>
    </span>
);

TaskInvoiceActions.propTypes = {
    invoice: PropTypes.shape({
        invoiceNumber: PropTypes.string.isRequired,
    }).isRequired,
};

export default TaskInvoiceActions;
